var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "dialogRef", staticClass: "sel-seat" }, [
    _c("div", { style: "width:" + _vm.boxWidth + "px;overflow:auto" }, [
      _vm.seatArray.length > 0
        ? _c(
            "div",
            [
              _c(
                "div",
                {
                  staticClass: "sm-div",
                  style: "left:" + (_vm.boxWidth / 2 + 185) + "px;"
                },
                [
                  _c("div", { staticClass: "sm-title" }, [
                    _c("span", { staticClass: "span" }, [
                      _vm._v(_vm._s(_vm.roomName))
                    ])
                  ]),
                  _vm._m(0)
                ]
              ),
              _vm._l(_vm.seatArray, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "sm-cell",
                    style:
                      "width:" +
                      _vm.boxWidth * 1.3 +
                      "px;height:" +
                      _vm.seatSize * 1.3 +
                      "px"
                  },
                  _vm._l(item, function(seat, col) {
                    return _c(
                      "div",
                      {
                        key: col,
                        staticClass: "dp-ib",
                        style:
                          "width:" +
                          _vm.seatSize * 1.3 +
                          "px;height:" +
                          _vm.seatSize * 1.3 +
                          "px;",
                        on: {
                          click: function($event) {
                            return _vm.handleChooseSeat(index, col)
                          }
                        }
                      },
                      [
                        seat.type == 0
                          ? _c("div", { staticClass: "sm-icon unselect" }, [
                              _c("div", { staticClass: "statusCss" }, [
                                _vm._v(_vm._s(seat.A))
                              ])
                            ])
                          : seat.type == 1
                          ? _c("div", { staticClass: "sm-icon select" }, [
                              _c("div", { staticClass: "statusCss" }, [
                                _vm._v(_vm._s(seat.A))
                              ])
                            ])
                          : seat.type == 2 || seat.type == 3
                          ? _c("div", { staticClass: "sm-icon hasSet" }, [
                              _c("div", { staticClass: "statusCss" }, [
                                _vm._v(_vm._s(seat.A))
                              ])
                            ])
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              })
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "noData" },
            [_c("el-empty", { attrs: { "image-size": 200 } })],
            1
          ),
      _c("div", { staticClass: "seat-foot" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.seatArray.length > 0,
                expression: "seatArray.length > 0"
              }
            ],
            staticClass: "fix-tips"
          },
          [
            _c("div", { staticClass: "v-tips" }, [
              _c("div", {
                style:
                  "width:" +
                  _vm.seatSize * 1.3 +
                  "px;height:" +
                  _vm.seatSize * 1.3 +
                  "px;background-color:#FFF;border-radius:6px;border: 1px solid #ccc;"
              }),
              _c("span", { staticClass: "span" }, [_vm._v("可选")])
            ]),
            _c("div", { staticClass: "v-tips" }, [
              _c("div", {
                style:
                  "width:" +
                  _vm.seatSize * 1.3 +
                  "px;height:" +
                  _vm.seatSize * 1.3 +
                  "px;background-color:#FFFF00;border-radius:6px;border: 1px solid #ccc;"
              }),
              _c("span", { staticClass: "span" }, [_vm._v("选中")])
            ]),
            _c("div", { staticClass: "v-tips" }, [
              _c("div", {
                style:
                  "width:" +
                  _vm.seatSize * 1.3 +
                  "px;height:" +
                  _vm.seatSize * 1.3 +
                  "px;background-color:#990000;border-radius:6px;border: 1px solid #ccc;"
              }),
              _c("span", { staticClass: "span" }, [_vm._v("锁定/预定")])
            ])
          ]
        ),
        _vm.showEdit
          ? _c("div", { staticClass: "tipLine" }, [
              _c("i", { staticClass: "el-icon-warning-outline iconCss" }),
              _vm._v("可选择区域进行锁定/解锁：")
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "areaDiv" },
          _vm._l(_vm.areaList, function(_item, _index) {
            return _c(
              "div",
              {
                key: _index,
                class: _item.areaType == 0 ? "rowFree" : "rowSelect",
                on: {
                  click: function($event) {
                    return _vm.selectArea(_item, _index)
                  }
                }
              },
              [
                _c("div", { staticClass: "areaTitle" }, [
                  _vm._v(_vm._s(_item.areaName) + ":")
                ]),
                _c("div", { staticClass: "areaValue" }, [
                  _vm._v("￥" + _vm._s(_item.price))
                ])
              ]
            )
          }),
          0
        ),
        _vm.showEdit
          ? _c(
              "div",
              { staticClass: "new-foot" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.createSeat(1, "生成一楼座位图")
                      }
                    }
                  },
                  [_vm._v("生成一楼座位图")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.createSeat("", "生成全部座位图")
                      }
                    }
                  },
                  [_vm._v("生成全部座位图")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.changeSeatStatus(3)
                      }
                    }
                  },
                  [_vm._v("锁定")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.changeSeatStatus(0)
                      }
                    }
                  },
                  [_vm._v("解锁")]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]),
    _vm.mArr.length > 0
      ? _c(
          "div",
          { staticClass: "sm-line-index", style: "left: " + 2 + "px;" },
          _vm._l(_vm.mArr, function(m, mindex) {
            return _c(
              "span",
              {
                key: mindex,
                staticClass: "span",
                style: "height:" + _vm.seatSize * 1.3 + "px;"
              },
              [_vm._v(_vm._s(m))]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sm-screen" }, [
      _c("span", { staticClass: "span" }, [_vm._v("银幕中央")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }